import { Routes } from '@angular/router';
import {
  CheckoutPageComponent,
  FrontPageComponent,
  OrderPageComponent,
  PdfViewerPageComponent,
  SuccessPageComponent,
  UnauthorizePageComponent,
} from '@oneqrew-partnertool/pages';
import { ConfirmExit, InitailPlansResolver, CustomerOrderPageGuard, PlanResolver, SalesPartnersResolver, OrderAppCustomerGuard } from '@oneqrew-partnertool/utils';

export const appRoutes: Routes = [
  {
    path: 'bestellung',
    component: FrontPageComponent,
    data: { isSubPage: false, isReloadablePage: true, isNewPlanPage: true },
    resolve: {
      plans: InitailPlansResolver,
      plan: PlanResolver,
      salesPartners: SalesPartnersResolver,
    },
    title: 'Bestellung shp - Abo-Vergleich'
  },
  {
    path: 'bestellung/order',
    component: OrderPageComponent,
    data: { isSubPage: false, isReloadablePage: true, isNewPlanPage: true, isOrderPage: true },
    resolve: {
      salesPartners: SalesPartnersResolver,
      plans: InitailPlansResolver
    },
    canActivate: [CustomerOrderPageGuard],
    title: 'Bestellung shp - Kunden- und Bestellinformationen'
  },
  {
    path: 'bestellung/pdf/:filename',
    component: PdfViewerPageComponent,
    data: {
      isReloadablePage: true
    },
    title: 'Bestellung shp - AVV Entwurf'
  },
  {
    path: 'bestellung/checkout',
    component: CheckoutPageComponent,
    data: { isSubPage: true, isNewCustomer: true  },
    canActivate: [OrderAppCustomerGuard],
    title: 'Bestellung shp - Bezahlinformationen'
  },
  {
    path: 'bestellung/success',
    component: SuccessPageComponent,
    canDeactivate: [ConfirmExit],
    canActivate: [OrderAppCustomerGuard],
    data: { isSubPage: false, isNewPlanPage: true},
    title: 'Bestellung shp - Erfolgreich bestellt'
  },
    {
    path: 'bestellung/unauthorized',
    component: UnauthorizePageComponent,
    data: { },
    title: 'Bestellung shp - Nicht autorisiert'
  },
  { path: '**', redirectTo: '/bestellung', pathMatch: 'full' ,  data: { isSubPage: false, isReloadablePage: true, isNewPlanPage: true }},
];
